(function () {
    "use strict";

    angular.module("fleetviewApp")
      .factory("LocationItem", [function () {
          function LocationItem(data, name) {
              var self = this;
              self.Name = name;
              self.Address = data.Address;
              self.Coords = data.Coords;
              self.TypeIcon = "ico-circle-plus";
              self.Type = -1;
              if (data.type) {
                  self.Type = data.type;
                  if (data.type === 1) {
                      self.TypeIcon = "ico-star";
                  } else if (data.type === 0) {
                      self.TypeIcon = "ico-clock-o";
                  }
              }
              if (data.location) {
                  data = data.location;
              }
              self.Icon = "destination";
              self.IconText = "D";
              // self.LineClass = (data.Address.StreetAddress === "") ? "noAddress" : "";
              self.CityStateZip = data.Address.City + ", " + data.Address.State + (data.Address.Zip !== null ? " " + data.Address.Zip : "");

              self.CountyStr = (data.Address.County !== "") ? data.Address.County + " County" : "";
              self.ALKObj = data;
              self.isVisible = false;

              self.showMe = function () {
                  self.isVisible = true;
              };

              self.hideMe = function () {
                  self.isVisible = false;
              };
          }

          return LocationItem;
      }]);
})();



// WEBPACK FOOTER //
// ./app/components/alkLocationItem.js